import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from '@/hooks/useTranslation';
import { NAMESPACES } from '@/i18n/namespaces';
import { toast } from 'react-toastify';
import { useSocialAuth } from '@/features/auth/hooks/useAuth';

const GoogleAuthCallback = () => {
  const navigate = useNavigate();
  const { t: tErrors } = useTranslation(NAMESPACES.ERRORS);
  const { t: tAuth } = useTranslation(NAMESPACES.AUTH);
  const { handleGoogleCallback } = useSocialAuth();
  
  // Use ref to ensure we only process the callback once
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent executing more than once
    if (hasProcessed.current) return;
    
    const processAuth = async () => {
      try {
        hasProcessed.current = true;
        const urlSearchParams = new URLSearchParams(window.location.search);
        
        // Log search params for debugging (remove in production)
        console.log("Processing Google callback with params:", 
          Object.fromEntries(urlSearchParams.entries()));
        
        // Process authentication with the code and state
        await handleGoogleCallback(urlSearchParams);
        
        // If we reach here, wait a bit for redirect to happen
        setTimeout(() => {
          navigate('/discover');
        }, 100);
      } catch (err) {
        console.error('Error processing Google auth callback:', err);
        toast.error(tErrors('auth.googleAuthFailed'));
        
        // Wait a bit before redirect
        setTimeout(() => {
          navigate('/');
        }, 1000);
      }
    };

    processAuth();
    
    // Cleanup function to handle component unmount
    return () => {
      hasProcessed.current = true;
    };
  }, []);

  return (
    <div className="flex flex-col items-center justify-center h-dvh p-4">
      <div className="mb-4">{tAuth('socialAuth.processing.google')}</div>
      <div className="w-12 h-12 border-t-4 border-blue-500 border-solid rounded-full animate-spin"></div>
    </div>
  );
};

export default GoogleAuthCallback; 